var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "p-4 text-center" },
        [
          _c("h1", { staticClass: "m-3 mb-5" }, [
            _vm._v("Seasonal Reservation Alert!"),
          ]),
          _vm._v(" "),
          [
            _c("h5", { staticClass: "mb-5 mt-5" }, [
              _vm._v(
                "📢 Our ski rental season begins on " +
                  _vm._s(_vm.season_start_date) +
                  " – bookings will be available from that day."
              ),
            ]),
            _vm._v(" "),
            _c("h5", { staticClass: "mb-5 mt-5" }, [
              _vm._v(
                "Thank you for your patience – we look forward to welcoming you soon!"
              ),
            ]),
          ],
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cmt-30 mb-5" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }